import { render, staticRenderFns } from "./ModalEdit.vue?vue&type=template&id=33fb064a&"
import script from "./ModalEdit.vue?vue&type=script&lang=js&"
export * from "./ModalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports